import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ChiSono from "@/pages/ChiSono";
import Servizi from "@/pages/Servizi";
import Prenotazioni from "@/pages/Prenotazioni";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Testimonianze from "@/pages/Testimonianze";
import Contatti from "@/pages/Contatti";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/chi-sono" element={<ChiSono />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/prenotazioni" element={<Prenotazioni />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/testimonianze" element={<Testimonianze />} />
            <Route path="/contatti" element={<Contatti />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
